// src/auth/LoginScreen.jsx
import { useState } from "react";
import {
  pageStyle, cardStyle, logoStyle, headingStyle,
  labelStyle, inputStyle, errorStyle, btnPrimaryStyle, linkBtnStyle, googleFont,
} from "./authStyles";

export default function LoginScreen({ onSwitch, onSuccess }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [busy,     setBusy]     = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const res  = await fetch("/.netlify/functions/wc-auth-login", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Login failed"); setBusy(false); return; }
      onSuccess(data);
    } catch {
      setError("Network error. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div style={pageStyle}>
      {googleFont}
      <div style={cardStyle}>
        <button onClick={() => onSwitch("landing")} style={{ ...linkBtnStyle, marginBottom: 16 }}>← Back to home</button>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={logoStyle}>✍️</div>
          <h1 style={headingStyle}>Writing Coach</h1>
          <p style={{ color: "#8b949e", fontSize: 13, margin: 0 }}>Sign in to your account</p>
        </div>

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={labelStyle}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required style={inputStyle} />
          </div>
          {error && <div style={errorStyle}>⚠ {error}</div>}
          <button type="submit" disabled={busy} style={btnPrimaryStyle(busy)}>
            {busy ? "Signing in…" : "Sign In →"}
          </button>
        </form>

        <div style={{ marginTop: 16, textAlign: "center", fontSize: 13, color: "#8b949e", display: "flex", flexDirection: "column", gap: 8 }}>
          <button onClick={() => onSwitch("forgot")} style={linkBtnStyle}>Forgot password?</button>
          <span>
            New here?{" "}
            <button onClick={() => onSwitch("signup")} style={{ ...linkBtnStyle, color: "#388bfd", fontWeight: 700 }}>
              Create an account
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}
